export default "__VITE_ASSET__D03YOggM__"